import { RESTAURANTS } from "../Constants/Endpoints";
import { ApiRequestInterceptor } from "./apiRequest";

export const fetchRestaurantRegister = async (body) => {
    const method = "POST";
    const response = await ApiRequestInterceptor(RESTAURANTS.addRestaurants, method, body);

    if (response.code === 201) {
        return response; // restaurante creado
    } else if (response.code === 400) {
        throw new Error("Datos inválidos para restaurante");
    } else {
        throw new Error("Error al registrar restaurante");
    }
};